import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["email", "linkedin", "name", "phone", "title"];
import React from "react";
import { Icon } from "../fa-icon";

var formatLinkedIn = function formatLinkedIn(inStr) {
  var defaultValue = {};
  if (!inStr) return defaultValue;
  var str = inStr instanceof URL ? inStr.href : inStr;
  var regex = /^(?:(?:https:\/\/)?(?:www\.)?(?:linkedin\.com|linked\.in)\/in\/)?([a-z0-9_.-]+)\/?$/i;
  var match = str.match(regex);
  if (!match) return defaultValue;
  var username = match[1];
  var url = "https://linkedin.com/in/".concat(username);
  return {
    username: username,
    url: url
  };
};

export var ContactInfo = function ContactInfo(_ref) {
  var email = _ref.email,
      linkedin = _ref.linkedin,
      name = _ref.name,
      phone = _ref.phone,
      title = _ref.title,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var isEditable = otherProps["data-editable"];

  var _formatLinkedIn = formatLinkedIn(linkedin),
      liUrl = _formatLinkedIn.url;

  return /*#__PURE__*/React.createElement("header", otherProps, /*#__PURE__*/React.createElement("h1", null, name || (isEditable ? "{Your name}" : "")), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title || (isEditable ? "{Your title}" : "")), /*#__PURE__*/React.createElement("div", {
    className: "contact"
  }, /*#__PURE__*/React.createElement("ul", null, (email || isEditable) && /*#__PURE__*/React.createElement("li", {
    "data-info": "email"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "envelope",
    title: "Email"
  }), /*#__PURE__*/React.createElement("a", {
    href: "mailto:".concat(encodeURIComponent(email)),
    target: "_blank",
    rel: "noopener noreferrer"
  }, email || (isEditable ? "{your@email.com}" : ""))), (phone || isEditable) && /*#__PURE__*/React.createElement("li", {
    "data-info": "phone"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "phone",
    title: "Phone"
  }), /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(encodeURIComponent(phone)),
    target: "_blank",
    rel: "noopener noreferrer"
  }, phone || (isEditable ? "your-phone-number" : ""))), liUrl && /*#__PURE__*/React.createElement("li", {
    "data-info": "linkedin",
    "data-ignore": true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "linkedin",
    title: "LinkedIn",
    brand: true
  }), /*#__PURE__*/React.createElement("a", {
    href: liUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, liUrl)))));
};